import {proxy, useSnapshot} from 'valtio';
import {StepWidgetStore, StepsPath, stepsMap} from '../routing/StepsRouting';
import {useWidget} from '../routing/StepsWizardContext';
import {GetNextBuyflowStepResponse} from '@/lib/TypesOpenApi';

const widget = stepsMap['BILLING']!.store;

// widget data expected to be loaded on previus page
export const usePaymentWidget = () =>
  useWidget(StepsPath.Verify /* alias for payment */, paymentWidget);

// TODO: replace after BE deployed
export type BillingWidget = any;

export interface PaymentWidget {
  /** Base widget to relay on */
  widget: StepWidgetStore;
  content?: GetNextBuyflowStepResponse;
  billingWidget: BillingWidget;
}

export const paymentWidget = proxy<PaymentWidget>({
  widget,
  get content() {
    return this.widget.content;
  },

  get billingWidget() {
    // extract product info from widget
    const widgets =
      this.content?.buyflowStep.buyflowWidgets
        // @ts-ignore
        ?.map(({billingWidget: w}) => w!)
        .filter((w: any) => !!w) || [];

    return widgets[0];
  },
});

export const usePaymentState = () => useSnapshot(paymentWidget);
